import { Box, Typography, Paper } from '@mui/material';
import { Dvr } from '@mui/icons-material';

export default function EmptyState() {
  const iconStyle = {
    margin: '8px 24px',
    width: '40px',
    height: '40px',
  };
  return (
    <Box
      sx={{
        borderRadius: '12px',
        height: '100%',
      }}
    >
      <Paper
        elevation={1}
        sx={{
          height: '100%',
          padding: '48px 32px',
          borderRadius: '12px',
          width: '100%',
          boxShadow: 'none',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src="/images/activity-empty-state.png"
          alt="Empty State"
          style={{
            width: { xxs: null, sm: '100%' },
            height: '100%',
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            margin: '0 auto',
            opacity: 0.1,
          }}
        />
        <Typography
          sx={{
            mb: 2,
            fontWeight: '700',
            fontSize: '28px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          This is where your ideas & introductions from your advisors will
          appear.
        </Typography>
        <Typography
          sx={{
            mb: 2,
            fontWeight: '400',
            fontSize: '20px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          So start inviting people to your advisory board! The bigger your
          board, the more ideas and advocates for you.
        </Typography>
        <Typography
          sx={{
            mb: 2,
            fontWeight: '700',
            fontSize: '20px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          Click below to start turning contacts into followers:
        </Typography>
        <Box>
          <img
            src="/icons/linkedin_logo.svg"
            alt="LinkedIn Logo"
            style={iconStyle}
          />
          <img
            src="/icons/facebook_logo.svg"
            alt="Facebook Logo"
            style={iconStyle}
          />
          <img src="/icons/x_logo.svg" alt="X Logo" style={iconStyle} />
        </Box>
        <Box>
          <img
            src="/icons/message_logo.svg"
            alt="Message Logo"
            style={iconStyle}
          />
          <Dvr
            sx={{
              color: '#0866FF',
              margin: '8px 24px',
              fontSize: '2.5rem',
            }}
          />
          <img src="/icons/email_icon.svg" alt="Email Logo" style={iconStyle} />
        </Box>
      </Paper>
    </Box>
  );
}
